'use client';

import discordIcon from '@/public/assets/iconv2/discord.svg';
import SomethingWentWrong from '@/public/assets/iconv2/something-went-wrong.svg';
import Text from '@/src/components/common/text';
import { errorBoundaryContent } from '@/src/content/errorBoundary';
import { useEffect } from 'react';

import Logo from '@/src/components/common/img/Logo';
import { social } from '@/src/constants/app/social';
import { socialPlatforms } from '@/src/constants/social';
import { Button } from '@/src/shadcn/components/ui/button';
import { RefreshCcw } from 'lucide-react';
import Image from 'next/image';
import Link from 'next/link';

const ErrorBoundary = ({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) => {
  useEffect(() => {
    console.error(error);
  }, [error]);

  const reload = () => {
    reset();
    window.location.reload();
  };

  return (
    <div className="absolute inset-0 flex flex-col items-center justify-center w-full p-6">
      <div className="w-full">
        <div className="flex items-center justify-center mb-8">
          <Image src={SomethingWentWrong} alt="something-went-wrong" className="w-24 h-24 sm:w-36 sm:h-36" />
        </div>
        <Text type="h3" className="text-4xl! font-semibold text-center" content={errorBoundaryContent.errorMessage} />
        <div className="space-y-2 text-center flex flex-col items-center justify-center mt-3">
          <div className="flex items-center justify-center">
            <Text type="h3" className="text-xl sm:text-2xl">
              {errorBoundaryContent.refreshPage}
            </Text>
          </div>

          <Button
            type="button"
            className="dark:text-accent text-success-foreground flex gap-2 items-center px-0 py-0 hover:opacity-80 transition-opacity"
            onClick={reload}
            variant="link"
          >
            <Text type="h3" className="text-xl sm:text-2xl" content={errorBoundaryContent.btnText} />
            <RefreshCcw className="w-4 h-4" />
          </Button>
        </div>

        <div className="text-center space-y-4">
          <Text
            type="h3"
            className="text-xl sm:text-2xl text-muted-foreground"
            content={errorBoundaryContent.getInTouchMessage}
          />
          <div className="flex justify-center items-center gap-2">
            <Button className="rounded-full px-4 py-2 hover:bg-accent/10 transition-colors">
              <Link href={social.discord} target="_blank" className="flex gap-2 items-center">
                <Logo logo={discordIcon} imgStyle="w-6 h-6" />
                <Text type="p" content={socialPlatforms.discord} className="capitalize" />
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ErrorBoundary;
